const submitAdvancedFlow = {
    data() {
        return {
            formSubmitStatus: {
                type: Boolean,
                default: false,
            },
        };
    },
    methods: {
        submitAdvancedFlow() {
            const courseDates = this.$storage.getStorageSync("courseDates") || {};
            const holidays = this.$storage.getStorageSync("holidays") || [];
            const venue = this.$storage.getStorageSync("venue") || {};

            // all data for simple events
            const data = {
                userId: window.currentUserId,
                courseDates,
                holidays,
                venue,
            };

            const formData = new FormData();

            formData.append("data", JSON.stringify(data));

            $.ajax({
                url: "/register-advanced-flow",
                method: "POST",
                data,
                dataType: "json",
            }).done((response) => {
                if (response.success) {
                    this.$storage.clearStorageSync();
                    window.onbeforeunload = null;
                    document.location.href = `/management-panel/advanced/${response.data.termdateId}`;
                }
            }).fail((jqXHR, textStatus) => {
                this.formSubmited = false;
                alert("Something went wrong with saving.");
            });
        },
    },
};

export default submitAdvancedFlow;
